module.exports = __webpack_public_path__ + "static/kedia_steel_corporation-674579b7a324ee98c6c589e6ac8985b6.png";